export const OlaSortingMapping = {
  "status": "Sorting by Status",
  "changed_ascending": "Sorting by Last Changed Ascending",
  "changed_descending": "Sorting by Last Changed Descending",
  "name": "Sorting by Name"
};
